import { Injectable } from '@angular/core';
import { DialogOverlayComponent } from '../components/dialog-overlay/components/dialog-overlay.component';

@Injectable({
    providedIn: 'root'
})
export class DialogOverlay {
    show(dialog: DialogOverlayComponent, message, className?: string) {
        return new Promise((resolve, reject) => {
            dialog.show(message, className);
            dialog.onOk.subscribe((response) => {
                dialog.hide();
                resolve(true);
            });
            dialog.onCancel.subscribe((response) => {
                dialog.hide();
                reject(false);
            });
        });
    }
}
